import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentAchievements = ({ achievements }) => {
  const getAchievementIcon = (type) => {
    const icons = {
      xp_milestone: 'Zap',
      quiz_perfect: 'Trophy',
      play_completed: 'CheckCircle2',
      streak_milestone: 'Flame',
      pronunciation_master: 'Mic',
      speed_reader: 'Gauge'
    };
    return icons?.[type] || 'Star';
  };

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <h2 className="text-2xl font-semibold text-card-foreground mb-4 flex items-center gap-2">
        <Icon name="Trophy" size={24} color="var(--color-primary)" />
        Recent Achievements
      </h2>
      {achievements?.length === 0 ? (
        <div className="text-center py-8">
          <Icon name="Trophy" size={48} className="text-muted-foreground mx-auto mb-3" />
          <p className="text-muted-foreground">Your achievements will appear here!</p>
        </div>
      ) : (
        <div className="space-y-3">
          {achievements?.map((achievement) => (
            <div 
              key={achievement?.id}
              className="bg-muted/50 rounded-lg p-4 hover:bg-muted transition-colors duration-150"
            >
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center">
                  <Icon name={getAchievementIcon(achievement?.type)} size={24} color="white" />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-semibold text-card-foreground mb-1">{achievement?.title}</h4>
                  <p className="text-sm text-muted-foreground mb-2">{achievement?.description}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-muted-foreground">{achievement?.earnedDate}</span>
                    <span className="text-sm font-semibold text-accent">+{achievement?.xpAwarded} XP</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentAchievements;